(function () {
  const recentlyTracked = new WeakSet();

  function analyticsAllowed() {
    const privacy = window.Shopify && window.Shopify.customerPrivacy;
    if (!privacy || typeof privacy.analyticsProcessingAllowed !== 'function') return true;
    return privacy.analyticsProcessingAllowed();
  }

  function itemIndex(card) {
    const explicitIndex = Number(card.dataset.frItemIndex || 0);
    if (explicitIndex > 0) return explicitIndex;

    const container = card.closest('[data-fr-home-products], [data-product-grid], #ResultsList, .product-grid');
    if (!container) return undefined;

    const cards = Array.from(container.querySelectorAll('[data-fr-product-click]'));
    const index = cards.indexOf(card);
    return index >= 0 ? index + 1 : undefined;
  }

  function eventPayload(card, link) {
    const datasetVariantId = String(card.dataset.frVariantId || '');
    let linkedVariantId = '';
    try {
      linkedVariantId = new URL(link.href, window.location.origin).searchParams.get('variant') || '';
    } catch (_) {}

    const variantId = /^\d{8,24}$/.test(linkedVariantId) ? linkedVariantId : datasetVariantId;
    const sku = !linkedVariantId || linkedVariantId === datasetVariantId
      ? String(card.dataset.frItemId || '')
      : '';
    const itemId = sku || variantId || card.dataset.productId || '';
    const price = Number(card.dataset.frPrice || 0);
    const index = itemIndex(card);
    const item = {
      item_id: String(itemId),
      item_name: card.dataset.frProductTitle || '',
      item_variant: card.dataset.frVariantTitle || '',
      price: Number.isFinite(price) ? price : 0,
      quantity: 1
    };

    if (index) item.index = index;

    return {
      currency: card.dataset.frCurrency || 'USD',
      item_list_name: card.dataset.frItemListName || 'Product List',
      product_id: String(card.dataset.productId || ''),
      variant_id: variantId,
      sku: sku,
      items: [item]
    };
  }

  function publish(card, link) {
    if (!analyticsAllowed() || recentlyTracked.has(card)) return;
    recentlyTracked.add(card);
    window.setTimeout(function () { recentlyTracked.delete(card); }, 1000);

    const payload = eventPayload(card, link);
    const publishShopify = window.Shopify && window.Shopify.analytics && window.Shopify.analytics.publish;
    if (typeof publishShopify === 'function') {
      try {
        publishShopify('framelune:select_item', payload);
      } catch (_) {}
    }

    const item = payload.items[0];
    const form = new FormData();
    form.set('event_name', 'select_item');
    form.set('product_id', payload.product_id);
    form.set('variant_id', payload.variant_id);
    form.set('sku', payload.sku);
    form.set('product_title', item.item_name);
    form.set('item_list_name', payload.item_list_name);
    form.set('currency', payload.currency);
    form.set('price', String(item.price || 0));
    if (item.index) form.set('item_index', String(item.index));

    if (navigator.sendBeacon && navigator.sendBeacon('/apps/framelune-rx/track', form)) return;

    fetch('/apps/framelune-rx/track', {
      method: 'POST',
      body: form,
      credentials: 'same-origin',
      keepalive: true
    }).catch(function () {});
  }

  function productCardFromEvent(event) {
    if (!(event.target instanceof Element)) return null;
    const link = event.target.closest('a[href*="/products/"]');
    const card = link && link.closest('[data-fr-product-click]');
    return card ? { card: card, link: link } : null;
  }

  document.addEventListener('click', function (event) {
    if (event.defaultPrevented || event.button > 0) return;
    const target = productCardFromEvent(event);
    if (target) publish(target.card, target.link);
  }, true);
})();
